import { useApiQuery } from '../useApiQuery';
import { operationsClient, apiGet } from '@/lib/api';
import { schedulerEndpoints } from '@/lib/api/endpoints';
import { schedulerKeys } from '@/lib/queryKeys';
import type { RouteDriftParams, RouteDriftResponse } from '@/types/scheduler';

/**
 * Scheduling v2 phase 4 — nightly route-efficiency snapshots (actual vs
 * optimal drive per tech/run). Powers the dispatch board's "Route insights"
 * panel; that panel is ambient, so failures never toast — it just stays
 * hidden. Snapshots are written by a nightly cron, so a short staleTime avoids
 * refetch churn on focus/remount without ever showing day-old data.
 */
export function useRouteDrift(range: RouteDriftParams, opts: { enabled?: boolean } = {}) {
  return useApiQuery<RouteDriftResponse>({
    queryKey: schedulerKeys.routeDrift(range),
    queryFn: ({ signal }) =>
      apiGet<RouteDriftResponse>(operationsClient, schedulerEndpoints.routeDrift(), {
        params: {
          from: range.from,
          to: range.to,
          ...(range.technicianId ? { technicianId: range.technicianId } : {}),
        },
        signal,
      }),
    enabled: opts.enabled ?? true,
    staleTime: 5 * 60 * 1000,
    showErrorToast: false,
  });
}
